// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuFilterContainer{display:var(--vuuFilterContainer-display,flex);flex:var(--vuuFilterContainer-flex);flex-direction:var(--vuuFilterContainer-flexDirection,column);gap:var(--salt-spacing-100);height:var(--vuuFilterContainer-height);overflow:auto}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
